/**
 * Calculate the aspect ratio from width and height.
 *
 * @param width - The width (can be number or value convertible to number)
 * @param height - The height (can be number or value convertible to number)
 * @returns The aspect ratio (width / height) or null if invalid input
 */
export const getAspectRatio = (width: unknown, height: unknown): number | null => {
	// Convert width and height to numbers, fallback to 0 if invalid
	const _width = typeof width === 'number' ? width : Number(width);
	const _height = typeof height === 'number' ? height : Number(height);

	// If either value is not a finite positive number, return null
	if (!Number.isFinite(_width) || !Number.isFinite(_height) || _width <= 0 || _height <= 0) {
		return null;
	}

	// Return the calculated aspect ratio
	return _width / _height;
};

export default getAspectRatio;
